<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage maumView"
    ref="maumView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">Create and customize<br />your own AI for yourself</div>
            <div class="workSlogan mobile">
              Create and customize<br />your own AI for<br />yourself
            </div>
            <div class="workTopDay">
              <p>마음AI 플랫폼 이노베이션</p>
              <ul>
                <li>PC / Mobile web</li>
                <li>2023.04.01</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://maum.ai" target="_blank" class="siteAddr">https://maum.ai</a>
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/maum"
                    title="마음대로 만드는 나만의 인공지능"
                    hashtags="플립커뮤니케이션즈,마음AI"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/maum"
                    title="마음대로 만드는 나만의 인공지능"
                    hashtags="플립커뮤니케이션즈,마음AI"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt">
            <marquee-text :duration="15"
              >&nbsp;Create and customize your own AI for yourself&nbsp;</marquee-text
            >
          </span>
          <img class="web" src="@/assets/images/works_view/maum/visual.jpg" alt="" />
          <img class="mobile" src="@/assets/images/works_view/maum/visual_m.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          인공지능(AI) 기술은 최근 몇 년간 눈부신 발전을 거듭하며 이제는 일상생활과 밀접한
          서비스에도 활발하게 사용되고 있습니다. 종합 인공지능 서비스 기업 마음AI는 API 커넥터 겸
          워크플로우 관리 도구인 ‘마음오케스트라’를 개발하고, 이를 활용해 다양한 AI 엔진과 서비스를
          연결한 맞춤형 AI 서비스를 직접 만들고 운영할 수 있는 AI 서비스 플랫폼을 오픈했습니다.
          그러나 배경지식이 없는 일반 소비자들이 AI 서비스를 이해하고 직접 사용하기란 쉽지 않은
          일이었습니다. 이에 마음AI는 플랫폼 UI/UX 개선의 필요성을 체감하고 홈페이지 진입부터 솔루션
          이용까지 모든 사용자 과정을 개선하는 플랫폼 혁신 프로젝트를 진행했습니다.
        </div>
      </div>
    </div>

    <!-- <kinesis-container event="scroll"> -->
    <div class="wideConts">
      <!--
<div
            class="swiper-slide"
            v-observe-visibility="{
              callback: visibilityChanged,
              intersection: {
                threshold: 0.2
              }
            }"
            v-for="(b, idx) in listData"
            :key="b.contSeq"
            :data-index="idx"
          >

       -->

      <!-- <ELEMENT v-sticky="{ zIndex: NUMBER, stickyTop: NUMBER, disabled: [true|false]}"> -->

      <!-- <div class="topVisual" v-observe-visibility="{ callback: observeTit, intersection: { threshold: 0.2 } }"> -->

      <!-- <div class="topVisual">
        <div class="bgOver"></div>
        <div class="titWrap" ref="titWrap">
          <div class="tit">Create and customize<br />your own AI for yourself</div>
        </div> -->

      <!-- <div class="topVisual" v-observe-visibility="{ callback: observeTit }">
        <div class="titWrap">
          <div class="tit">Create and customize<br />your own AI for yourself</div>
        </div> -->

      <!-- <div class="circleWrap">
          <div class="rotateWrap">
            <div class="circle rotate" id="rotate">
              <img src="@/assets/images/works_view/maum/circle.svg" alt="" />
            </div>
            <p>AI</p>
          </div>
          <div class="circle sm" id="rotate2">
            <img src="@/assets/images/works_view/maum/circle_sm.svg" alt="" />
          </div>
        </div>
        <div class="floatImg f1" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img01.png" alt="" />
        </div>
        <div class="floatImg f2" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img02.png" alt="" />
        </div>
        <div class="floatImg f3" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img03.png" alt="" />
        </div>
        <div class="floatImg f4" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img04.png" alt="" />
        </div>
        <div class="floatImg f5" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img05.png" alt="" />
        </div>
        <div class="floatImg f6" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img06.png" alt="" />
        </div>
        <div class="floatImg f7" v-observe-visibility="(isVisible, entry) => observeActive2(isVisible, entry)">
          <img src="@/assets/images/works_view/maum/visual_img07.png" alt="" />
        </div>
      </div> -->
      <div
        class="maumCon intro"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="viewInner">
          <div class="graph">
            <div class="leftWrap">
              <div class="round"><div class="txt">일반 소비자</div></div>
              <div class="roundBg bg1"></div>
              <div class="roundBg bg2"></div>
            </div>
            <div class="arrowLine">
              <img src="@/assets/images/works_view/maum/arrow_intro.svg" alt="" />
            </div>
            <div class="rightBg">
              <div class="bgShape"></div>
              <div class="logo">
                <img src="@/assets/images/works_view/maum/logo.svg" alt="" />
              </div>
            </div>
            <div class="rightWrap">
              <div class="round">
                <div class="sm">homepage</div>
                <div class="txt">홈페이지 진입</div>
              </div>
              <div class="round">
                <div class="sm">solution</div>
                <div class="txt">솔루션 이용</div>
              </div>
            </div>
          </div>
          <div class="txtWrap">
            <div class="tit">maum.ai<br />Platform Innovation</div>
            <p>
              배경지식이 없는 일반 소비자가 AI 서비스를 이해하고 <br />직접 사용할 수 있도록
              홈페이지 진입부터 솔루션 이용까지 <br class="web" />모든 사용자 과정을 개선하는 플랫폼
              혁신 프로젝트를 진행했습니다.
            </p>
          </div>
          <div class="scrollDown">
            <div class="rotating">
              <img src="@/assets/images/works_view/maum/scrolldown.svg" alt="scroll down" />
            </div>
            <div class="arrow">
              <img src="@/assets/images/works_view/maum/scrolldown_arrow.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="maumCon goal"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="viewInner">
          <div class="txtWrap">
            <span class="smallTit">Goal</span>
            <div class="tit">물 흐르듯 이어지는 USER FLOW</div>
            <p>
              사용자가 UI/UX의 리드만 따라가면 자신이 원하는 AI 서비스를 손쉽게 만들 수 있도록
              <br class="web" />유저 플로우를 개선하는 데 집중했습니다.
            </p>
          </div>
          <div
            class="webFrame rolling"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="screenWrap">
              <div class="screen">
                <img src="@/assets/images/works_view/maum/goal_pc.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="txtWrap mid">
            <p>
              마음AI의 다양한 인공지능 모델과 서비스를 효과적으로 보여주기 위해 각각의 기능에 대한
              정보를 직관적으로 소개하고, <br class="web" />이를 이용해 자신만의 AI 서비스를 만들어
              사용할 수 있도록 흐름에 맞게 정보를 재배열했습니다.
            </p>
            <p>
              누구나 쉽게 가입하고 사용할 수 있는 SaaS형 플랫폼의 특성에 맞춰 플랫폼에 처음 접속했을
              때 <br class="web" />어떤 작업을 진행해야 하는지 안내하는 온보딩 요소를 제공합니다.
            </p>
          </div>
          <div
            class="phoneWrap"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="phone">
              <div class="screen">
                <img src="@/assets/images/works_view/maum/goal_m01-2.jpg" alt="" />
              </div>
              <div class="frame">
                <div class="screen">
                  <img src="@/assets/images/works_view/maum/goal_m01-1.jpg" alt="" />
                </div>
              </div>
            </div>
            <div class="phone">
              <div class="screen">
                <img src="@/assets/images/works_view/maum/goal_m02-2.jpg" alt="" />
              </div>
              <div class="frame">
                <div class="screen">
                  <img src="@/assets/images/works_view/maum/goal_m02-1.jpg" alt="" />
                </div>
              </div>
            </div>
            <div class="phone">
              <div class="screen">
                <img src="@/assets/images/works_view/maum/goal_m03-2.jpg" alt="" />
              </div>
              <div class="frame">
                <div class="screen">
                  <img src="@/assets/images/works_view/maum/goal_m03-1.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bgRotating">
          <img src="@/assets/images/works_view/maum/ellipse01.svg" alt="" />
        </div>
      </div>

      <div
        class="maumCon point type1"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="txtWrap">
          <span class="smallTit wide">Point.1</span>
          <div class="tit">유기적으로 연결된 메뉴</div>
          <p>
            마음AI에서 제공하는 마음오케스트라, AI 휴먼, 챗봇 등의 서비스를 <br class="web" />한눈에
            둘러보고 관심 있는 서비스는 개발까지 바로 이어질 수 있도록 <br class="web" />연결성을
            높인 레이아웃으로 구성했습니다.
          </p>
        </div>
        <div class="webFrame fade">
          <div class="screenWrap sliderFade swiper-container">
            <div class="swiper-wrapper">
              <div class="screen swiper-slide">
                <img src="@/assets/images/works_view/maum/point1_screen01.jpg" alt="" />
              </div>
              <div class="screen swiper-slide">
                <img src="@/assets/images/works_view/maum/point1_screen02.jpg" alt="" />
              </div>
              <div class="screen swiper-slide">
                <img src="@/assets/images/works_view/maum/point1_screen03.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="scrollDown">
          <div class="rotating">
            <img src="@/assets/images/works_view/maum/scrolldown.svg" alt="scroll down" />
          </div>
          <div class="arrow">
            <img src="@/assets/images/works_view/maum/scrolldown_arrow.svg" alt="" />
          </div>
        </div>
        <div class="bgRotating">
          <img src="@/assets/images/works_view/maum/ellipse02.svg" alt="" />
        </div>
      </div>
      <div
        class="maumCon point type2"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="txtWrap">
          <span class="smallTit wide">Point.2</span>
          <div class="tit">누구나 쉽게 이해하는 AI 서비스</div>
          <p>
            AI가 인간을 대체해 활동할 수 있는 영역을 쉽게 이해할 수 있도록 직업 이름을 제품명으로
            사용했습니다. <br class="web" />또한, 다양한 AI 서비스를 한눈에 파악하고 비교할 수
            있도록 제품의 사용처와 사용 방법, <br class="web" />지원 업무 등의 정보는 카드 형태로
            축약해 효과적으로 전달합니다.
          </p>
        </div>
        <div class="webFrame fade">
          <div class="screenWrap sliderFade swiper-container">
            <div class="swiper-wrapper">
              <div class="screen swiper-slide">
                <img src="@/assets/images/works_view/maum/point2_screen01.jpg" alt="" />
              </div>
              <div class="screen swiper-slide">
                <img src="@/assets/images/works_view/maum/point2_screen02.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="aiListWrap">
          <ul class="aiList">
            <li>
              <p>AI Receptionist</p>
            </li>
            <li>
              <p>AI Korean Tutor</p>
            </li>
            <li>
              <p>AI Announcer</p>
            </li>
            <li>
              <p>AI Trainer</p>
            </li>
            <li>
              <p>AI Chat Friend</p>
            </li>
            <li>
              <p>AI English Tutor</p>
            </li>
            <li>
              <p>AI Call Center Agent</p>
            </li>
            <li>
              <p>AI IR/Shareholder<br />Relations Officer</p>
            </li>
          </ul>
        </div>
        <div class="responsive">
          <div class="img">
            <img src="@/assets/images/works_view/maum/responsive.png" alt="" />
          </div>
          <div class="bgRotating">
            <img src="@/assets/images/works_view/maum/ellipse03.svg" alt="" />
          </div>
        </div>
      </div>
      <div
        class="maumCon point type3"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="txtWrap">
          <span class="smallTit wide">Point.3</span>
          <div class="tit">원스톱으로 모든 것이 가능한<br />마음오케스트라</div>
          <p>
            마음AI에서 개발한 API와 외부 API를 활용해 워크플로우를 생성할 수 있는
            <br class="web" />마음오케스트라에서는 드래그&amp;드롭으로 간단하게 API를 연동할 수
            있습니다.
          </p>
          <p>
            ‘빠르게 시작하기’의 템플릿 기능을 활용해 배경지식이 없는 사용자도 쉽고 빠르게
            <br class="web" />나만의 AI 서비스를 만들 수 있습니다.
          </p>
        </div>
        <div class="sliderP3 swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="@/assets/images/works_view/maum/point3_screen_slide1.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@/assets/images/works_view/maum/point3_screen_slide2.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@/assets/images/works_view/maum/point3_screen_slide3.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@/assets/images/works_view/maum/point3_screen_slide4.jpg" alt="" />
            </div>
          </div>
        </div>
        <div class="txtWrap mid">
          <p>
            또한, 워크플로우, 챗봇, 엔진 등의 이용 현황을 한눈에 파악할 수 있는 통계를 함께
            제공합니다.
          </p>
        </div>
        <div class="flowListWrap">
          <ul class="flowList">
            <li>
              <img src="@/assets/images/works_view/maum/point3_screen_flow1.png" alt="" />
            </li>
            <li>
              <img src="@/assets/images/works_view/maum/point3_screen_flow2.png" alt="" />
            </li>
            <li>
              <img src="@/assets/images/works_view/maum/point3_screen_flow3.png" alt="" />
            </li>
            <li>
              <img src="@/assets/images/works_view/maum/point3_screen_flow4.png" alt="" />
            </li>
          </ul>
        </div>
        <div class="scrollDown">
          <div class="rotating">
            <img src="@/assets/images/works_view/maum/scrolldown.svg" alt="scroll down" />
          </div>
          <div class="arrow">
            <img src="@/assets/images/works_view/maum/scrolldown_arrow.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="maumCon point type4">
        <div class="circleWrap">
          <div class="circle rotate" id="rotate">
            <img src="@/assets/images/works_view/maum/circle.svg" alt="" />
          </div>
          <p>GPT</p>
        </div>
        <div class="txtWrap">
          <span class="smallTit wide">Point.4</span>
          <div class="tit">비교하고 만드는 <br class="web" />나만의 챗봇</div>
          <p>
            최근 가장 큰 화두였던 챗 GPT를 비롯해 GPT 계열 언어 모델을 <br class="web" />연동해 여러
            종류의 챗봇을 경험하고 비교할 수 있습니다.
          </p>
        </div>
        <div
          class="imgWrap img1"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="desc">
            <p>개인의 설정을 반영해 <br class="web" />가장 적합한 챗봇을 선택할 수 있습니다.</p>
          </div>
          <div class="webFrame">
            <div class="screenWrap">
              <div class="screen">
                <img src="@/assets/images/works_view/maum/point4_screen01.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="imgWrap img2"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div class="webFrame">
            <div class="screenWrap">
              <div class="screen">
                <img src="@/assets/images/works_view/maum/point4_screen01.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="desc rolling">
            <p>
              어떤 러닝과 사고 회로를 거쳐 답변을 가져오는지 <br class="web" />챗봇의 파이프라인
              플로우를 제공합니다.
            </p>
            <p>
              또한, 마음오케스트라에서 해당 챗봇을 사용할 수 있게 연결해 <br class="web" />AI
              서비스를 신속하게 구현할 수 있는 환경을 조성했습니다.
            </p>
            <div class="rollingTxt">
              <img src="@/assets/images/works_view/maum/point4_rollingTxt.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </kinesis-container> -->

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-KiupIBK' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">IBK기업은행 기업 디지털 채널 혁신 사업</strong>
          <strong class="mobile"
            >IBK기업은행<br />
            기업 디지털 채널 혁신 사업</strong
          >
        </div>

        <div class="engBg kiupEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";

// import {
//   TweenLite
// } from "gsap/all";

Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "MaumAI",
  /* head: {
    title: {
      inner: '마음AI'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      W: 0,
      icoInter: null,
      icoVal: 0,
      scrollTop: 0,
      throttle: 100,
      meta: {
        siteName: "마음AI 홈페이지 및 플랫폼 | 플립커뮤니케이션즈",
        title: "마음AI 홈페이지 및 플랫폼",
        desc:
          "마음AI에서 개발한 API 커넥터와 워크플로 관리 도구를 활용해 다양한 AI 엔진과 서비스를 연결한 맞춤형 AI 서비스를 직접 생성 및 운영할 수 있는 AI 서비스 플랫폼을 오픈했습니다. 사용자 중심의 UI/UX 개선을 통해 일반 소비자도 손쉽게 AI 서비스를 이해하고 활용할 수 있도록 지원합니다.",
        keywords:
          "마음AI, 인공지능 서비스, AI 플랫폼, 마음오케스트라, 사용자 경험, UI/UX 개선, 플랫폼 혁신, SaaS 플랫폼, 온보딩 요소, 메뉴 연결성, AI 서비스 이해, API 연동, 워크플로우 생성, GPT 챗봇, 챗봇 경험 비교",
        url: "https://www.pulip.com/works/maumAI",
        img: "https://www.pulip.com/pulip-logo.jpg"
      }
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    // vuejs Bicint
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/maum").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    observeActive2(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add("active");
      }
    },

    handleScroll: function(e) {
      // this.scrollTop = e.target.scrollTop;
      console.log("scroll :", e.target.scrollTop);
    },
    observeTit(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add("active");
        setTimeout(() => {
          this.$refs.titWrap.style.position = "fixed";
        }, 200);
      } else {
        entry.target.classList.remove("active");
        setTimeout(() => {
          this.$refs.titWrap.style.position = "sticky";
        }, 200);

        //console.log('else');
      }
    },
    stickyActor() {
      const stickyContainer = document.querySelector(".topVisual");
      const stickyContent = document.querySelector(".titWrap");
      const [target] = document.getElementsByTagName("body");

      const initialTopInPx = window.innerHeight * 0.2083;

      target.addEventListener("scroll", () => {
        const scrollTop = target.pageYOffset || document.documentElement.scrollTop;
        const containerRect = stickyContainer.getBoundingClientRect();

        if (scrollTop >= containerRect.top - initialTopInPx) {
          stickyContent.style.position = "fixed";
          stickyContent.style.top = `${initialTopInPx}px`;
        } else {
          stickyContent.style.position = "absolute";
          stickyContent.style.top = `${initialTopInPx}px`;
        }

        if (scrollTop >= containerRect.bottom - stickyContent.offsetHeight - initialTopInPx) {
          stickyContent.style.position = "absolute";
          stickyContent.style.top = `${containerRect.height -
            stickyContent.offsetHeight -
            initialTopInPx}px`;
        }
      });
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize, this.stickyActor);
    window.addEventListener("scroll", () => {
      console.log("in created");
    });
    this.handleResize();
    // window.addEventListener('scroll', this.scrollRotate);
    // this.scrollRotate();
  },
  beforeDestroy() {
    try {
      this.sliderFade.destroy();
      this.sliderP3.destroy();
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("scroll", this.stickyActor);
      // window.removeEventListener('scroll', this.scrollRotate);
      clearInterval(this.icoInter);
    } catch (err) {}
  },
  mounted() {
    this.stickyActor();

    this.target = document.querySelector(".maumView");
    const [target] = document.getElementsByTagName("body");

    target.addEventListener("scroll", () => {
      console.log(target.scrollTop);
      var theta = (target.scrollTop / 90) % Math.PI;

      document.getElementById("rotate").style.transform = "rotate(" + theta + "rad)";
    });

    this.sliderFade = new window.Swiper(".sliderFade.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: "auto",
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      effect: "fade"
    });

    this.sliderP3 = new window.Swiper(".sliderP3.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      speed: 1500,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      breakpoints: {
        751: {
          spaceBetween: 80
        }
      }
    });
  },
  beforeUnmount() {
    this.target.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
